export class Proposal {
	constructor(data) {
		this._id = data._id;
		this.name = data.name;
		this.subject = data.subject;
		this.template = data.template;
		this.user_id = data.user_id;
	}
}
